// Arrow hover for the section's collection cards. Delegated on the document:
// global.js binds each card once, so the copies the ticker clones later would
// otherwise never animate.
(function () {
  const FLAG = "collectionsListArrowHover";
  if (document.documentElement.dataset[FLAG] === "true") return;
  document.documentElement.dataset[FLAG] = "true";

  const cardFrom = (event) =>
    event.target?.closest?.(".collections-list-section .collection-card");

  const setState = (card, isActive) => {
    card.classList.toggle("hover-active", isActive);
    card.classList.toggle("hover-inactive", !isActive);
  };

  const activate = (event) => {
    const card = cardFrom(event);
    if (!card) return;
    if (event.relatedTarget && card.contains(event.relatedTarget)) return;
    setState(card, true);
  };

  const deactivate = (event) => {
    const card = cardFrom(event);
    if (!card) return;
    if (event.relatedTarget && card.contains(event.relatedTarget)) return;
    setState(card, false);
  };

  document.addEventListener("mouseover", activate);
  document.addEventListener("mouseout", deactivate);
  document.addEventListener("focusin", activate);
  document.addEventListener("focusout", deactivate);
})();
